<ng-container *transloco="let convert;">
  <div class="dealer-credit">
    <h2 class="focus-outline-none header mb-0" tabindex="-1" #pageHeading aria-describedby="pageDescription">
      {{convert('profileManagement.dealercredit.buyerCreditLineInfo')}}
    </h2>
    <p class="subheader" id="pageDescription">
      @if (organization?.organizationProfile?.eligibleToPurchase) {
        <span>
          {{convert('profileManagement.dealercredit.eligibleToBuy')}}
        </span>
      }
      @if (organization?.organizationProfile?.eligibleToSell) {
        <span>
          {{convert('profileManagement.dealercredit.eligibleToSell')}}
        </span>
      }
      {{convert('profileManagement.dealercredit.textDefaultCredit')}} {{ defaultSource ? convert('profileManagement.dealercredit.textSet') + defaultSource.financeSourceName : convert('profileManagement.dealercredit.textNotSet') }}.
      @if (showError) {
        <error-message aria-live="assertive"></error-message>
      }
      @if (showSuccess) {
        <success-message aria-live="assertive" [message]="message"></success-message>
      }
    </p>
    <app-legacy-table
      [columns]="creditColumns"
      [data]="financeSources"
      [tenantName]="tenantName$ | async"
      id="dealer-credit-table"
      [caption]="convert('profileManagement.dealercredit.captionBuyerCredit')"
      >
      @for (row of financeSources; track row) {
        <table-row
          [columns]="creditColumns"
          [row]="row"
          [class.defaultSource]="isDefault(row)"
          >
          <table-cell *appTableCell="let row; column: 'financeSource'"> {{ row.financeSourceName }}</table-cell>
          <table-cell *appTableCell="let row; column: 'creditLimit'">
            {{ effectiveCreditLimit(row) | currency: 'USD':true:'1.0-2' }}</table-cell
            >
            <table-cell *appTableCell="let row; column: 'expDate'">
              {{ localizeDate(row.temporaryCreditLimitExpirationDate) }}</table-cell
              >
              <table-cell *appTableCell="let row; column: 'options'">
                @if (!isDefault(row)) {
                  <button
                    data-track-elem="button"
                    data-track-name="Set Default"
                    class="btn btn-link py-0 ps-0"
                    (click)="updateDefault(row.financeSourceUuid, row.achSelected)"
                    [attr.aria-label]="convert('profileManagement.dealercredit.labelSet') + row.financeSourceName + convert('profileManagement.dealercredit.labelDefault')"
                    >
                    {{convert('profileManagement.dealercredit.setDefault')}}
                  </button>
                }
                @if (isDefault(row)) {
                  <span class="py-0 ps-0 default-btn">{{convert('profileManagement.dealercredit.textDefault')}}</span>
                }
              </table-cell>
            </table-row>
          }
        </app-legacy-table>

        <!-- <h1 class="header mb-0">Seller Fees</h1>
        <p class="subheader">Your pickup contact may handle sales for this dealer and other parties.</p> -->
      </div>
      @if (isBuyerAuctionFeesEnabled) {
        <br>
          <div class="auction-fees">
            <h2 class="focus-outline-none header mb-0" tabindex="-1" #pageHeading aria-describedby="pageDescription">
              {{convert('profileManagement.dealercredit.auctionAndServiceFees')}}
            </h2>
            <br>
              <app-legacy-table
                [columns]="auctionColumns"
                [data]="auctionFeeSources"
                [tenantName]="tenantName$ | async"
                id="auction-fees-table"
                [caption]="convert('profileManagement.dealercredit.auctionAndServiceFees')"
                >
                @for (row of auctionFeeSources; track row) {
                  <table-row
                    [columns]="auctionColumns"
                    [row]="row"
                    >
                    <table-cell *appTableCell="let row; column: 'auctionLane'"> {{ row.auctionName }}</table-cell>
                    <table-cell *appTableCell="let row; column: 'serviceFee'">
                      <button
                        data-track-elem="button"
                        data-track-name="View Fee Schedule"
                        class="btn btn-link py-0 ps-0"
                        allytmln="View Fee Schedule"
                        (click)="viewScheduleFees(row)"
              [attr.aria-label]="convert('profileManagement.dealercredit.labelView') +
          row.auctionName + convert('profileManagement.dealercredit.labelFeeSchedule')"
                        >
                        {{convert('profileManagement.dealercredit.viewFeeSchedule')}}
                      </button>
                    </table-cell>
                  </table-row>
                }
              </app-legacy-table>
            </div>
          }
          <app-service-fee-schedule-modal [modalId]="feeScheduleModalId">
          </app-service-fee-schedule-modal>
        </ng-container>
